// Musical theater performances — Isaias Jiménez (2002–present)
// Source: tour sheet provided by Isaias (PDF)
var musicals = [
  { title: 'Promises, Promises', role: '1st Trumpet', year: '2002' },
  { title: 'Babes in Arms', role: '1st Trumpet', year: '2003' },
  { title: 'Victor/Victoria', role: '1st Trumpet', year: '2006' },
  { title: 'Sweet Charity', role: 'Sub 1st & 2nd Trumpet', year: '2009' },
  { title: 'The Sound of Music', role: '1st Trumpet', year: '2009' },
  { title: '¡Que Planton!', role: '1st Trumpet', year: '2009' },
  { title: 'A Chorus Line', role: '1st Trumpet', year: '2010–2011' },
  { title: 'Sinos Dejan', role: '1st Trumpet', year: '2011–2013' },
  { title: 'Mary Poppins', role: '1st & 2nd Trumpet', year: '2012–2013' },
  { title: 'Chicago', role: '1st Trumpet', year: '2013' },
  { title: 'Fiddler on the Roof', role: 'Sub 1st Trumpet', year: '2013' },
  { title: 'Wicked', role: '1st Trumpet', year: '2013–2014' },
  { title: 'Mentiras', role: '1st Trumpet (special shows)', year: '2013+' },
  { title: 'The Addams Family', role: 'Sub 1st Trumpet', year: '2014' },
  { title: 'Applause!', role: '1st Trumpet', year: '2016' },
  { title: 'Young Frankenstein', role: '1st & 2nd Trumpet (CD + taped orchestra)', year: '2016' },
  { title: 'Man of La Mancha', role: 'Sub 1st Trumpet', year: '2016' },
  { title: 'Billy Elliot', role: '1st Trumpet', year: '2017' },
  { title: 'Jersey Boys', role: '1st Trumpet — 400 shows', year: '2023–2026' },
];

export default musicals;
